import React from 'react';

interface SessionOneIntroProps {
  onBegin: () => void;
}

export default function SessionOneIntro({ onBegin }: SessionOneIntroProps) {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <span style={{
        background: '#64DAD2',
        color: '#001F8C',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        padding: '4px 12px',
        borderRadius: '20px',
        display: 'inline-block',
        marginBottom: '16px',
      }}>
        Session 1 of 3
      </span>
      <div style={{ marginBottom: '12px' }}>
        <span style={{
          background: '#fffbeb',
          color: '#92400e',
          border: '1px solid #fbbf24',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          padding: '4px 10px',
          borderRadius: '20px',
          display: 'inline-block',
        }}>
          Adviser only — not shown to client
        </span>
      </div>
      <h1 style={{ fontSize: '32px', fontWeight: 700, color: '#001F8C', marginBottom: '8px' }}>
        Session 1 — Adviser Briefing
      </h1>
      <p style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: '16px', marginBottom: '32px' }}>
        What you'll cover with the client today
      </p>

      <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 300px' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '16px' }}>
            What we'll cover today
          </p>
          {[
            { title: 'Your position', desc: 'Income, tax, and where you stand today' },
            { title: 'Your framework', desc: 'Where you sit on the Baby Steps ladder' },
            { title: 'Your Freedom Number', desc: 'The exact number that makes work optional' },
            { title: 'The Gap', desc: 'The difference between where you\'re heading and where you want to be' },
            { title: 'Your plan', desc: 'Pension, investments, mortgage, and the cascade that closes it' },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#64DAD2', marginTop: '6px', flexShrink: 0 }} />
              <div>
                <p style={{ fontWeight: 600, color: '#001F8C', marginBottom: '2px' }}>{item.title}</p>
                <p style={{ fontSize: '14px', color: '#6b7280' }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{
          flex: '0 0 280px',
          background: '#fffbeb',
          border: '1px solid #fbbf24',
          borderRadius: '12px',
          padding: '20px',
          height: 'fit-content',
        }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
            Before the client arrives
          </p>
          <p style={{ fontSize: '14px', color: '#78350f', marginBottom: '8px' }}>
            Set up the Voyant do-nothing plan before the client arrives. Enter the client's current position with no changes applied — this becomes the baseline the session improves on.
          </p>
          <p style={{ fontSize: '14px', color: '#78350f' }}>
            Allow 60–90 minutes.
          </p>
        </div>
      </div>

      <button
        onClick={onBegin}
        style={{
          marginTop: '40px',
          background: '#64DAD2',
          color: '#001F8C',
          border: 'none',
          borderRadius: '8px',
          padding: '14px 32px',
          fontSize: '16px',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Begin — client is ready →
      </button>
    </div>
  );
}
